import { useEffect, useState } from 'react'
import API from '../../../api'

export default function useAdventureReviews(activityId) {
  const [reviews, setReviews] = useState([])

  useEffect(() => {
    API(`/api/adventure/v1/${activityId}/reviews/`)
      .get()
      .then((results) => {
        const reviews = results?.reviews?.toSorted((a, b) => (new Date(b.publishDatetime) - new Date(a.publishDatetime)))
        setReviews({ ...results, reviews })
      })
  }, [activityId])

  return {
    reviews,
  }
}
